import initialStateSubscribable from '@/shared/mixins/store/subscribableData/initialState';

import { TimestampsGpsState } from './types';

export default function initialState(): TimestampsGpsState {
  return {
    ...initialStateSubscribable(),
  };
}
